/* tslint:disable:max-line-length */
export var getNotInterfaceErrorMsg = function getNotInterfaceErrorMsg(serviceName) {
  return "".concat(serviceName, " is not an @Interface");
};
export var getServiceAlreadyBoundErrorMsg = function getServiceAlreadyBoundErrorMsg(serviceName) {
  return "Service ".concat(serviceName, " is already bound!");
};
export var getBoundToAnotherInstanceErrorMsg = function getBoundToAnotherInstanceErrorMsg(serviceName) {
  return "Service ".concat(serviceName, " bound to another instance!");
};
export var getUnknownServiceErrorMsg = function getUnknownServiceErrorMsg(serviceName) {
  return "".concat(serviceName, " not available");
};
export var getUnknownServiceMethodErrorMsg = function getUnknownServiceMethodErrorMsg(serviceName, methodName) {
  return "".concat(serviceName, " does not have ").concat(methodName, " method");
};
//# sourceMappingURL=errorMessages.js.map